import { render, staticRenderFns } from "./CardPendencia.vue?vue&type=template&id=636efd69"
import script from "./CardPendencia.vue?vue&type=script&lang=js"
export * from "./CardPendencia.vue?vue&type=script&lang=js"
import style0 from "./CardPendencia.vue?vue&type=style&index=0&id=636efd69&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports